/* ==========================================================================
   NUA DREAMS — cajones.js
   Los tres paneles laterales de la tienda (el menú, el buscador y la cesta)
   son la misma pieza y se comportan igual, así que se gobiernan desde aquí:

     · bloquean el scroll del fondo sin que la página dé un salto
     · atrapan el tabulador dentro del panel
     · se cierran con Escape, con el aspa y tocando fuera
     · devuelven el foco al botón que los abrió

   Sólo puede haber un cajón abierto a la vez.

   Abrir y cerrar se pide desde el marcado, sin una línea de JS por cajón:

       data-accion="abrir-cesta"   →  abre el elemento con [data-cesta]
       data-accion="cerrar-cesta"  →  cierra el que esté abierto

   Antes cada cajón traía su propio listener de click sobre el documento y su
   propio archivo; ahora hay un solo repartidor para los tres.

   Los disparadores de la cesta y del buscador son ENLACES de verdad, a /cart y
   a /search. Aquí se les corta el paso con preventDefault para abrir el cajón
   en su sitio; si este archivo no llega a cargar, siguen llevando a su página.

   Al abrirse, el cajón lanza el evento nua:cajon-abierto (sube por el
   documento desde el propio .cajon), para quien tenga algo que preparar.
   ========================================================================== */

var NuaCajon = (function () {

  var activo = null;   /* { caja, panel, disparador } */
  var saltando = false; /* Mayús+Tab de paso por el centinela (ver keydown) */

  /* Dar el foco NO debe mover la página. Por defecto el navegador «trae a la
     vista» lo que enfocas, y con la cabecera pegajosa se lía: al cerrar el
     cajón devolvíamos el foco al botón del menú y la página se iba 400 px
     hacia arriba. preventScroll lo evita. */
  function enfocar(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); }
    catch (e) { el.focus(); }
  }

  /* Lo que se puede tabular dentro del panel, en orden y sólo si se ve */
  function enfocables(panel) {
    var todos = panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),' +
      'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    );
    var salida = [];
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      if (el.hasAttribute("data-cajon-centinela")) continue;
      if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) salida.push(el);
    }
    return salida;
  }

  /* El centinela del final del panel. Hay cosas tabulables que no se pueden
     contar desde aquí: los botones de Apple Pay, Google Pay y Shop Pay de la
     cesta los pinta Shopify dentro de un shadow DOM cerrado, y para
     querySelector no existen. Si el tabulador saltaba al principio en cuanto
     llegaba a «Finalizar compra» —lo último que se veía desde aquí—, esos
     botones no se podían alcanzar con el teclado.

     Así que al final del panel va un <span> tabulable e invisible: el
     navegador pasa por todo lo que hay antes, se vea desde aquí o no, y al
     llegar al centinela el foco vuelve al principio. Se pone una sola vez por
     panel, fuera de lo que repinta la cesta. Y sirve también al revés: con
     Mayús+Tab desde el primero, el foco salta al centinela y el navegador
     retrocede desde él hasta el último botón, el de pago exprés incluido. */
  function centinela(panel) {
    if (panel.querySelector(":scope > [data-cajon-centinela]")) return;
    var fin = document.createElement("span");
    fin.tabIndex = 0;
    fin.className = "nua-oculto-visual";
    fin.setAttribute("data-cajon-centinela", "");
    panel.appendChild(fin);
  }

  /* Al quitar la barra de scroll la página se ensancha y todo se mueve.
     Se compensa con el mismo ancho de relleno a la derecha. */
  function bloquearFondo() {
    var hueco = window.innerWidth - document.documentElement.clientWidth;
    if (hueco > 0) document.body.style.paddingRight = hueco + "px";
    document.body.classList.add("nua-bloqueado");
  }

  function soltarFondo() {
    document.body.classList.remove("nua-bloqueado");
    document.body.style.paddingRight = "";
  }

  function abrir(caja, disparador) {
    if (!caja) return;
    if (activo && activo.caja === caja) return;
    if (activo) cerrar(false);

    caja.hidden = false;
    bloquearFondo();

    var panel = caja.querySelector('[role="dialog"]') || caja;
    activo = { caja: caja, panel: panel, disparador: disparador || null };
    centinela(panel);

    /* Sólo los botones que ya declaran aria-expanded lo llevan (los tres de
       la cabecera). «Añadir a la cesta» también abre el cajón, pero no es un
       desplegable y no le corresponde el atributo. */
    if (disparador && disparador.hasAttribute("aria-expanded")) {
      disparador.setAttribute("aria-expanded", "true");
    }

    /* Aviso para quien necesite saber que su cajón se ha abierto: la cesta
       pide entonces el estado del código de descuento, en vez de pedirlo al
       cargar cada página aunque nadie la abra. */
    caja.dispatchEvent(new CustomEvent("nua:cajon-abierto", { bubbles: true }));

    /* Si el panel señala dónde quiere el foco, ahí va: en el buscador es el
       campo, no el aspa de cerrar, que es lo primero del marcado. */
    var preferido = panel.querySelector("[data-cajon-foco]");
    if (preferido) { enfocar(preferido); return; }

    var lista = enfocables(panel);
    if (lista.length) enfocar(lista[0]);
  }

  /* ¿Se le puede devolver el foco? Tiene que seguir en la página, verse y no
     estar desactivado. */
  function util(el) {
    return !!(el && document.contains(el) && !el.disabled && el.getClientRects().length);
  }

  /* El botón que abre este cajón, el primero que se vea: el icono de la
     cabecera. Es adonde vuelve el foco cuando el que abrió el cajón ya no
     sirve. */
  function abridor(caja) {
    var botones = document.querySelectorAll('[data-accion^="abrir-"]');
    for (var i = 0; i < botones.length; i++) {
      var accion = botones[i].getAttribute("data-accion");
      var destino = document.querySelector("[data-" + accion.slice(accion.indexOf("-") + 1) + "]");
      if (destino === caja && util(botones[i])) return botones[i];
    }
    return null;
  }

  /* devolverFoco: false cuando el cajón se cierra porque el usuario ha
     pulsado un enlace y la página ya va a otro sitio.

     Si el que lo abrió ya no sirve —«Añadir a la cesta» se ha desactivado
     porque era la última unidad, o se ha ido de la página—, el foco va al
     botón de la cabecera que abre este mismo cajón. Antes se quedaba en el
     <body> y quien usa teclado tenía que empezar la página desde arriba. */
  function cerrar(devolverFoco) {
    if (!activo) return;

    var quien = activo;
    activo = null;

    quien.caja.hidden = true;
    soltarFondo();

    if (quien.disparador && quien.disparador.hasAttribute("aria-expanded")) {
      quien.disparador.setAttribute("aria-expanded", "false");
    }
    if (devolverFoco === false) return;
    enfocar(util(quien.disparador) ? quien.disparador : abridor(quien.caja));
  }

  /* ---------- Repartidor de clicks ---------------------------------------- */

  document.addEventListener("click", function (ev) {
    var el = ev.target.closest ? ev.target.closest("[data-accion]") : null;

    if (el) {
      var accion = el.getAttribute("data-accion") || "";
      var guion  = accion.indexOf("-");
      var verbo  = accion.slice(0, guion);
      var cual   = accion.slice(guion + 1);

      if (verbo === "abrir") {
        ev.preventDefault();
        abrir(document.querySelector("[data-" + cual + "]"), el);
        return;
      }
      if (verbo === "cerrar") { cerrar(); return; }
    }

    /* Un enlace de dentro del cajón se lleva la página a otro sitio: el cajón
       se quita de en medio, pero sin robarle el foco al destino, que ya lo
       tiene la página nueva. */
    if (!activo) return;
    var enlace = ev.target.closest ? ev.target.closest("a[href]") : null;
    if (enlace && activo.panel.contains(enlace)) cerrar(false);
  });

  document.addEventListener("keydown", function (ev) {
    if (!activo) return;

    if (ev.key === "Escape") {
      ev.preventDefault();
      cerrar();
      return;
    }
    if (ev.key !== "Tab") return;

    var lista = enfocables(activo.panel);
    if (!lista.length) return;

    var primero = lista[0];

    /* Hacia delante no se corta aquí: lo hace el centinela del final (ver
       arriba), para no saltarse lo que no se ve desde este archivo.

       Hacia atrás, desde el primero, tampoco se elige el último a mano: el
       último que se ve desde aquí es «Finalizar compra», y los botones de pago
       exprés, que van detrás dentro de su shadow DOM, se quedaban sin
       alcanzar. Así que el foco se pone en el centinela y NO se corta la
       tecla: el navegador hace su Mayús+Tab desde ahí y retrocede al último
       tabulable de verdad, esté donde esté. Mientras, el centinela no debe
       mandar el foco al principio (`saltando`). */
    if (ev.shiftKey && document.activeElement === primero) {
      var fin = activo.panel.querySelector(":scope > [data-cajon-centinela]");
      if (fin) {
        saltando = true;
        enfocar(fin);
        window.setTimeout(function () { saltando = false; }, 0);
      } else {
        ev.preventDefault();
        enfocar(lista[lista.length - 1]);
      }
    } else if (!activo.panel.contains(document.activeElement)) {
      ev.preventDefault();
      enfocar(primero);
    }
  });

  /* El foco ha llegado al centinela: se ha pasado todo el panel y vuelve al
     principio. Salvo cuando lo ha puesto ahí el Mayús+Tab de arriba, que sólo
     lo usa de trampolín. */
  document.addEventListener("focusin", function (ev) {
    if (!activo || saltando || !ev.target.hasAttribute || !ev.target.hasAttribute("data-cajon-centinela")) return;
    var lista = enfocables(activo.panel);
    if (lista.length) enfocar(lista[0]);
  });

  return {
    abrir: abrir,
    cerrar: cerrar
  };
})();
